import { color, Fn, mix, smoothstep } from 'three/tsl';

// The Spartan solar palette shared by every glow/energy effect: black up to
// a threshold, through orange, out to white-hot at full intensity.
const TRANSPARENT_BASE = color('#000000');
export const GLOW_ORANGE = color('#ff7a2e');
export const GLOW_WHITE = color('#ffffff');

export const glowRamp = Fn(([t]: [any]) => {
  const toOrange = mix(TRANSPARENT_BASE, GLOW_ORANGE, smoothstep(0, 0.3, t));

  return mix(toOrange, GLOW_WHITE, smoothstep(0.3, 1, t));
});

// The same three-stop shape, but with every stop supplied by the caller --
// for effects that must never fade toward black (an energy line should read
// as hot at its dimmest, not as absence) and want their low/mid/high tuned
// live. Shared rather than redefined per effect so the ramp's SHAPE stays
// identical across them even when the colours differ.
export const solarRamp = Fn(
  ([t, colorLow, colorMid, colorHigh]: [any, any, any, any]) => {
    const toMid = mix(colorLow, colorMid, smoothstep(0, 0.45, t));

    return mix(toMid, colorHigh, smoothstep(0.45, 1, t));
  }
);
